<template>
    <v-main>
      <CommunicationDraftContainer />
    </v-main>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from "vue";
import CommunicationDraftContainer from '@/container/communication/CommunicationDraftContainer.vue';

export default defineComponent({
  components: {
    CommunicationDraftContainer,
  },
});
</script>
